import { Grid, Bones } from '@simplywallst/ui-core';

export const NarrativeSkeletonLoader = () => {
  return (
    <Grid
      gap="16px"
      templateColumnsLg="2fr 1fr"
      templateRowsLg="152px 40px minmax(800px, 1fr)"
      templateRows="152px 40px 500px 800px"
    >
      <Grid>
        <Bones borderRadiusLg="x2" />
      </Grid>
      <Grid columnLg="2" rowLg="span 3">
        <Bones borderRadiusLg="x2" />
      </Grid>
      <Grid>
        <Bones borderRadiusLg="x2" />
      </Grid>
      <Grid>
        <Bones borderRadiusLg="x2" />
      </Grid>
    </Grid>
  );
};
